import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  iconContainer: {
    display: "grid",
    placeItems: "center",
  },
  modalContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(12),
  },
  submitButton: {
    width: 150,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  textField: {
    maxWidth: 450,
    "& .MuiInputBase-root": {
      padding: theme.spacing(2),
    },
  },
  modal: {
    maxWidth: 600,
  },
}));
